export const macrons = ["ā", "ē", "ī", "ō", "ū"];
export const vowels = ["a", "e", "i", "o", "u", ...macrons];
export const letters = ["A", "E", "H", "I", "K", "M", "N", "O", 
                        "P", "R", "T", "U", "W", "NG", "W"];
